import {
  ADD_FAQ_SCREENS,
  GET_FAQ_SCREENS,
  RESET_FAQ_SCREENS,
  TOGGLE_FAQ_SCREENS,
  UPDATE_FAQ_SCREENS,
} from "../actionTypes";

const faqScreensReducer = (state = null, action) => {
  switch (action.type) {
    case GET_FAQ_SCREENS:
      return action.payload;

    case ADD_FAQ_SCREENS:
      return [...state, action.payload];

    case UPDATE_FAQ_SCREENS:
      return state.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_FAQ_SCREENS:
      return state.map((item) =>
        item.id !== action.payload.id
          ? item
          : { ...item, enabled: !item.enabled }
      );

    case RESET_FAQ_SCREENS:
      return null;

    default:
      return state;
  }
};

export default faqScreensReducer;
